<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Daftar Jurnal</h5>
            </template>
    
            <div class="big-filter-label filter-form-wrapper mb-3">
                <b-row class="align-items-start justify-content-between">
                    <b-col md="12" lg="9">
                        <b-row>
                            <b-col >
                                <b-form-group class="form-inline filter-form-date" label-for="filterDate" label="Tanggal Request">
                                    <div class="d-flex align-items-center search-input-wrapper">
                                        <b-form-input
                                            v-model="input.fromDate" name="fromDate"
                                            id="filterDate"
                                            type="date"
                                        ></b-form-input>
                                        <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
                                        <b-form-input 
                                            v-model="input.toDate" name="toDate"
                                            type="date"
                                        ></b-form-input>
                                    </div>
                                </b-form-group>
                                <b-form-group class="form-inline" label-for="filterJenis" label="Cabang">
                                    <div>
                                        <multiselect v-model="input.cabang" tag-placeholder="Pilih Cabang" placeholder="Pilih Cabang" label="name" track-by="id" :options="cabangOption" :multiple="true" :close-on-select="false" @tag="addCabang"></multiselect>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-col cols="12">
                    <div class="filter-btn-wrapper">
                        <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isSubmitting" @click="onReset">Reset</b-button>
                    </div>
                </b-col>
            </div>
            <b-button class="mr-2 mb-2" variant="pgiBtn" name="dataGadaiBaruBtn" @click="modalDataGadaiBaru(1)">
                Download Data Gadai Baru
            </b-button>
            <b-button class="mr-2 mb-2" variant="pgiBtn" name="dataPembayaranBtn" @click="modalDataGadaiBaru(2)">
                Download Data Lelang
            </b-button>
            <b-button class="mb-2" variant="pgiBtn" name="dataPembayaranBtn" @click="modalDataGadaiBaru(3)">
                Download Data Pembayaran
            </b-button>
        </b-card>

        <ModalConfirm id="modal-confirm-data-gadai-baru" title="Confirm Data Gadai Baru" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mencetak laporan Data Gadai Baru ini?" @submit="openLaporanDownload(1)" />
        <ModalConfirm id="modal-confirm-data-lelang" title="Confirm Data Lelang" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mencetak laporan Data Lelang ini?" @submit="openLaporanDownload(2)" />
        <ModalConfirm id="modal-confirm-data-pembayaran" title="Confirm Data Pembayaran" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mencetak laporan Data Pembayaran?" @submit="openLaporanDownload(3)" />
        <b-modal id="modal-download-excel" centered title="Download Excel" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isSubmitting">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" target="_blank"  download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'daftar-surat-bpkb',
    data(){
        return{
            initStatus: 0,
            isSubmitting: false,
            
            input:{
                fromDate: null,
                toDate: null,
                cabang:[]
            },
            
            cabangOption:[],
            filePathDownload:''
        }
    }, 
    methods: {
        
        //----------------- Fungsi Inisialisasi -----------------
      
        init(){
            this.initStatus = 0
            this.isSubmitting = true
            let getCabang = this.$axios.get("cabang/all-selection").then(response => {
                this.cabangOption = response.data
            })

            Promise.all([getCabang]).then(() => {
                this.initStatus = 1
                this.isSubmitting = false
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },


        //----------------- Fungsi Ambil Data Cek Gadai -----------------

        addCabang (newTag) {
            const tag = {
                id: newTag.id,
                name: newTag.name
            }
            this.cabangOption.push(tag)
            this.input.cabang.push(tag)
        },

        modalDataGadaiBaru(modul){
            if (this.input.fromDate == null) {
                this.$helper.toastErr(this, 'Mohon isi tanggal dari')
                return
            }
            if (this.input.toDate == null) {
                this.$helper.toastErr(this, 'Mohon isi tanggal sampai')
                return
            }
            if(this.input.cabang.length == 0){
                this.$helper.toastErr(this, 'Mohon pilih cabang min 1')
                return
            }

            if (modul === 1) {
                this.$bvModal.show("modal-confirm-data-gadai-baru")
            } 
            if (modul === 2) {
                this.$bvModal.show("modal-confirm-data-lelang")
            }
            if (modul === 3) {
                this.$bvModal.show("modal-confirm-data-pembayaran")
            }
        },

        openLaporanDownload(modul) {
            this.isSubmitting = true
            this.$bvModal.show('modal-download-excel')

            if (modul === 1) {
                this.$bvModal.hide("modal-confirm-data-gadai-baru")
            } 
            if (modul === 2) {
                this.$bvModal.hide("modal-confirm-data-lelang")
            }
            if (modul === 3) {
                this.$bvModal.hide("modal-confirm-data-pembayaran")
            }
          
            setTimeout(() => { this.axiosLaporanDownload(modul) }, 500)
        },

        axiosLaporanDownload(modul){
            let query = ''
            let url = ''
            if (modul === 1) {
                url = 'journal/export/gadai'
            } 
            if (modul === 2) {
                url = 'journal/export/lelang'
            }
            if (modul === 3) {
                url = 'journal/export/pembayaran'
            }
          
           const cabangIds = Array.from(this.input.cabang, item => (item.id));
            query = "?cabangIds=" + cabangIds + "&fromDate="+this.input.fromDate+"&toDate="+this.input.toDate
            this.$axios.get(url+query).then(response => {
                this.filePathDownload = response.data.data
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$bvModal.hide('modal-download-excel')
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        onReset(){
            this.input.fromDate = null
            this.input.toDate = null
            this.input.cabang = []
        },
    },

    created(){
        this.init()
    }
}
</script>
<style>

</style>